var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"question",attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v(_vm._s(_vm.question))])]),_c('div',{staticClass:"answer"},[_vm._v("\n    "+_vm._s(_vm.answer)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }